import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ReviewReasonComponent } from 'src/app/admin/components/review-reason/review-reason.component';
import { AppComponent } from 'src/app/app.component';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
declare let require: any;
const FileSaver = require('file-saver');

@Component({
  selector: 'app-admin-knowledge-exp',
  templateUrl: './admin-knowledge-exp.component.html',
  styleUrls: ['./admin-knowledge-exp.component.css'],
})
export class AdminKnowledgeExpComponent implements OnInit {
  updateForm: FormGroup;
  private getApi = environment.url + environment.knowledgeGet;
  private updateStatusApi = environment.url + environment.updateStatus;
  /**
   * Constructs the AdminKnowledgeExpComponent with required services.
   * Initializes the update form and mobile query listener.
   * @param changeDetectorRef Reference to Angular's change detector for triggering change detection.
   * @param media Service to match media queries for responsive design.
   * @param getdata Service to retrieve values or data needed by the component.
   * @param fb FormBuilder service for creating reactive forms.
   * @param makeapi Service for making API calls.
   * @param dialog Material dialog service for opening dialogs.
   * @param notify Service for displaying notifications.
   * @param appCom Reference to the root AppComponent.
   * @param http Angular HttpClient for HTTP requests.
   */
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private getdata: ValueService,
    private fb: FormBuilder,
    private makeapi: ApiService,
    public dialog: MatDialog,
    private notify: NotifyService,
    private appCom: AppComponent,
    private http: HttpClient
  ) {
    // Initialize the update form with an incubator ID field
    this.updateForm = this.fb.group({
      incubatorId: [''],
    });

    // Initialize the mobile query listener to detect changes in the mobile query
    this.mobileQuery = media.matchMedia('(max-width: 992px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
  }
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  ngAfterViewInit(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  incubaterName;
  /**
   * OnInit lifecycle hook.
   * Retrieves the incubator name from session storage and calls the
   * getDataApi and guidelineDatas methods.
   */
  ngOnInit(): void {
    // Retrieve the incubator name from session storage
    this.incubaterName = sessionStorage.getItem('adminIncubName');

    // Set the incubator ID in the update form
    let getform = this.updateForm.value;
    getform.incubatorId = sessionStorage.getItem('incubator');
    this.updateForm.patchValue(getform);

    // Fetch the data from the API
    this.getDataApi();

    // Fetch the guideline data
    this.guidelineDatas();
  }
  getValue: any = {};
  /**
   * Fetches data from the API using the incubator ID from session storage,
   * shows a loading indicator during the request, and updates the component's
   * data on success.
   */
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('incubator'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
      });
  }
  pickColor(val) {
    return this.getdata.questionStatus(val);
  }
  pickWidth(val) {
    return this.getdata.statusWidth(val);
  }
  innerValue(val) {
    return this.getdata.StatusName(val);
  }
  /**
   * Downloads a PDF file using the FileSaver library.
   * @param value The URL of the PDF file to download.
   */
  download(value: string) {
    const pdfUrl = value;
    const pdfName = 'your_pdf_file';
    // Use the FileSaver library to download the PDF file
    FileSaver.saveAs(pdfUrl, pdfName);
  }
  /**
   * Submits the approval button for the given key and status.
   * Shows a loader while the request is being processed.
   * Removes the control from the updateForm after the request is completed.
   * Refreshes the data on success.
   *
   * @param keys - The unique identifier for the item to approve.
   * @param id - The current status of the item.
   */
  approveBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          // Remove the control from the form so that it is not visible again
          this.updateForm.removeControl(keys);
          // Refresh the data
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Submits the rejection button for the given key and status.
   * Shows a loader while the request is being processed.
   * Removes the control from the updateForm after the request is completed.
   * Refreshes the data on success.
   *
   * @param keys - The unique identifier for the item to approve.
   * @param id - The current status of the item.
   */
  rejectBtn(keys, id) {
    const fc = new FormControl('');
    this.updateForm.addControl(keys, fc);
    this.updateForm.controls[keys].setValue(id);
    this.getdata.amizhthLoader('show');
    let getform = this.updateForm.value;
    this.makeapi
      .method(this.updateStatusApi, getform, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseMessage);
          this.updateForm.removeControl(keys);
          this.getDataApi();
        } else {
          this.notify.notifyError(data.responseMessage);
        }
      });
  }
  /**
   * Opens the ReviewReasonComponent dialog to review an item with the given key and status.
   * Refreshes the data after the dialog is closed.
   *
   * @param key - The unique identifier for the item to review.
   * @param status - The current status of the item.
   */
  reviewBtn(key, status) {
    const dialogRef = this.dialog.open(ReviewReasonComponent, {
      // Set the width of the dialog to 390px
      width: '390px',
      // Pass the key and status to the dialog component
      data: { _key: key, _status: status },
    });

    // Subscribe to the dialog's afterClosed observable to refresh the data
    dialogRef.afterClosed().subscribe((result) => {
      // Refresh the data after the dialog is closed
      this.getDataApi();
    });
  }
  guidelinesBtn(data) {
    this.appCom.guidelinesModal(data);
  }
  guidelineValue: any = [];
  guidelineDatas() {
    this.http.get('/assets/json/guideline.json').subscribe((data) => {
      this.guidelineValue = data[1].questions;
    });
  }
  step = 0;
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }
  prevStep() {
    this.step--;
  }
}
